import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b7f1564"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "drawer_content",
  style: {"height":"100%","box-sizing":"border-box","display":"flex","flex-direction":"column","padding-top":"20px"}
}
const _hoisted_2 = {
  class: "titleButton",
  style: {"flex-shrink":"0","align-items":"center"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "新建送货单", -1))
const _hoisted_4 = {
  class: "xiafa",
  style: {"padding-left":"20px"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("确定 ")
const _hoisted_6 = { style: {"flex-shrink":"0","padding-top":"16px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_9 = { style: {"flex-grow":"1","height":"1px","overflow":"auto"} }

import { ref, watch, toRefs,reactive,nextTick } from 'vue'	
import { getbatch, getissed } from '@/service/main/invoices/documentsManagement';
import { ElMessage, ElMessageBox,ElLoading,ElTable } from 'element-plus';
// import { getCreatingShipOrderPage,systemDeNo} from '@/service/main/supplier/index'
import { readERP, getDeliveryOrderManagementPage, getCreatingShipOrderPage, systemDeNo,createDeliOrders,
    createDeliOrder, getOrderData, secondJundgment, getDeliveryDetailsData, deleteJundgment, nonstandardList, createNonstandad } from '@/service/main/supplier/index'
import { getInspectionMethod } from '../switchCase'
import Pagination from "@/components/Pagination/index.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
	visible:{
		type:Boolean,
		default:false
	},
	deliverInfo:{
		type:Object,
		default:()=>{
      return {}
    }
	}
},
  emits: ['update:visible','loadData','handOk'],
  setup(__props, { expose, emit: emits }) {

const props = __props




const {  deliverInfo } = toRefs(props)

const innerVisible = ref(false)
const loading = ref(false) // 初始不显示加载状态

const detailData = ref([])
const TableRef = ref()
const tableDataItems = ref<number>(0)

// 定义新建送货单接口参数
const saveData = reactive({
  purchaseID: 0,
  deliveryNo: "",
  deliveryType: "",
  goodsDeliveryDetailsInputList: [] as {
    projectCode: string;
    code: string;
    name: string;
    specificationModel: string;
    long: number;
    high: number;
    width: number;
    weight: number;
    unit: string;
    minUnit: string;
    deliveryQuantity: number;
    goodsDeliveryId: number;
    purchaseNo: string;
    PurchaseType: string;
  }[]
});
// 新建送货单确定
const confirmNewDeliveryOrder = () => {
    saveData.deliveryNo = creatingShipOrderParams.DeliveryNo;
    saveData.goodsDeliveryDetailsInputList = [];
    saveData.goodsDeliveryDetailsInputList = checkRows.value
    console.log('checkRows.value',checkRows.value)
    ElMessageBox.confirm("是否确认新建送货单？", "提示", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(() => {
        loading.value = true; // 开始加载时显示加载状态
       
        createDeliOrder(saveData).then((res) => {
          // drawers.value = false;
          // getDeDetails();
          TableRef.value.clearSelection()
          ElMessage.success("新建送货单成功");
          emits('handOk')
          hide()
          loading.value = false; 
        });
      })
      .catch(() => {
        ElMessage.info("已取消删除");
        loading.value = false; 
      });
};


const show = (scope:any) => {
    innerVisible.value = true
    loading.value = true; // 开始加载时显示加载状态
    creatingShipOrderParams.PurchaseID = scope.id
    saveData.purchaseID = scope.id
    saveData.deliveryType = scope.purchaseType
    // drawer.value = true
    systemCreateNo()
}
const hide = () => {
  innerVisible.value = false
  detailData.value = []
  emits('handOk')
}
// 定义新建送货单中选中的数据
const checkRows = ref([])
// 步骤条内容
let tableHeight = ref(0)
// onMounted(() => {
    tableHeight.value = window.innerHeight - 50;
// })
const handleSelectionChange = (val: any) => {
    checkRows.value = val
    console.log('val',val)
}

// 查询新建送货单列表数据接口参数定义
const creatingShipOrderParams = reactive({
    PurchaseID: "",
    DeliveryNo: "",
    PurchaseName: "",
    PurchaseCode: "",
    specificationModel: "",
    PageNo: 1,
    PageSize: 20
})
const getreset = () => {
    // creatingShipOrderParams.PurchaseID = ""
    creatingShipOrderParams.DeliveryNo = ""
    creatingShipOrderParams.PurchaseName = ""
    creatingShipOrderParams.PurchaseCode = ""
    creatingShipOrderParams.specificationModel = ""
    creatingShipOrderParams.PageNo = 1
    creatingShipOrderParams.PageSize = 20
    getCreatingShipOrderData()
}
// 关闭新建送货单抽屉时的事件(Close)
const handleClose = () => { 
    creatingShipOrderParams.PurchaseID = ""
    creatingShipOrderParams.DeliveryNo = ""
    creatingShipOrderParams.PurchaseName = ""
    creatingShipOrderParams.PurchaseCode = ""
    creatingShipOrderParams.specificationModel = ""
    creatingShipOrderParams.PageNo = 1
    creatingShipOrderParams.PageSize = 20
    detailData.value = []
    checkRows.value = []
    TableRef.value.clearSelection() // 使用内置方法清除所有选中状态（如果你的需求是清除所有选中，用这个就够了）
}


// 获取系统生成的送货单号,获取送货单详情
const systemCreateNo = () => {
    systemDeNo().then((res) => {
        creatingShipOrderParams.DeliveryNo = res.data
        getCreatingShipOrderData()
    })
}

// 获取新建送货单列表数据
const getCreatingShipOrderData = () => {
    getCreatingShipOrderPage( creatingShipOrderParams).then((res: any) => {
        const { data } = res

        let arr = data.rows.map((item:any) => {
            const matchedUpdate = checkRows.value.find((update:any) => update.xuHao === item.xuHao);
            return matchedUpdate ? { ...item, ...matchedUpdate } : item;
        });

        detailData.value = arr   
        tableDataItems.value = data.totalRows
        loading.value = false; // 开始加载时显示加载状态
    })
}

// 新增/修改弹框数量为0不可选择
const selectableFunction = (row: any) => {
    if (row.isCheck == false) {
        return true
    } else {
        return false
    }
}
expose({show,hide})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: innerVisible.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((innerVisible).value = $event)),
    direction: "rtl",
    size: "90%",
    onClose: handleClose,
    "show-close": false,
    "with-header": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              type: checkRows.value.length == 0 ? 'info' : 'primary',
              disabled: checkRows.value.length == 0,
              onClick: confirmNewDeliveryOrder
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["type", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_form, {
            model: _unref(creatingShipOrderParams),
            "label-width": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 5 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "品名:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(creatingShipOrderParams).PurchaseName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(creatingShipOrderParams).PurchaseName) = $event)),
                            clearable: "",
                            placeholder: "请输入品名"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 5,
                    class: "marginleft"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "品号:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(creatingShipOrderParams).PurchaseCode,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(creatingShipOrderParams).PurchaseCode) = $event)),
                            clearable: "",
                            placeholder: "请输入品号"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 5,
                    class: "marginleft"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "规格型号:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(creatingShipOrderParams).specificationModel,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(creatingShipOrderParams).specificationModel) = $event)),
                            clearable: "",
                            placeholder: "请输入规格型号"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 8,
                    class: "marginleft"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            icon: "el-icon-search",
                            onClick: getCreatingShipOrderData
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            icon: "el-icon-refresh-right",
                            onClick: getreset
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives((_openBlock(), _createBlock(_unref(ElTable), {
            data: detailData.value,
            border: "",
            style: {"width":"100%"},
            "row-key": "xuHao",
            ref_key: "TableRef",
            ref: TableRef,
            "max-height": _unref(tableHeight),
            onSelectionChange: handleSelectionChange,
            "default-sort": { prop: 'isCheck', order: 'ascending' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                align: "center",
                width: "60",
                type: "selection",
                "reserve-selection": "",
                selectable: selectableFunction
              }),
              _createVNode(_component_el_table_column, {
                label: "序号",
                width: "60",
                align: "center",
                type: "index"
              }),
              _createVNode(_component_el_table_column, {
                label: "项目编号",
                align: "center",
                prop: "projectCode",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                label: "物料序号",
                align: "center",
                prop: "xuHao"
              }),
              _createVNode(_component_el_table_column, {
                label: "主件品号",
                align: "center",
                prop: "mainCode",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                label: "品名",
                align: "center",
                prop: "name",
                width: "160"
              }),
              _createVNode(_component_el_table_column, {
                label: "品号",
                align: "center",
                prop: "code",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                label: "规格型号",
                align: "center",
                width: "250",
                sortable: "",
                prop: "specificationModel"
              }),
              _createVNode(_component_el_table_column, {
                label: "单位",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(scope.row.unit), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "检验方式",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(_unref(getInspectionMethod)(scope.row.inspectionMethod)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "是否结束",
                align: "center",
                prop: "isEnd",
                width: "160"
              }),
              _createVNode(_component_el_table_column, {
                label: "ERP采购数",
                align: "center",
                prop: "purchaseQuantity"
              }),
              _createVNode(_component_el_table_column, {
                label: "已推ERP数",
                align: "center",
                prop: "erpDeliveryQuantity"
              }),
              _createVNode(_component_el_table_column, {
                label: "退货数",
                align: "center",
                prop: "returnQuantity"
              }),
              _createVNode(_component_el_table_column, {
                label: "本次发货数量",
                align: "center",
                width: "160"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_input_number, {
                    min: "0",
                    class: "edit-pipeline",
                    modelValue: scope.row.deliveryQuantity,
                    "onUpdate:modelValue": ($event: any) => ((scope.row.deliveryQuantity) = $event),
                    modelModifiers: { number: true },
                    mix: scope.row.notPurchaseNumber,
                    size: "small"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "mix"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "max-height"])), [
            [_directive_loading, loading.value]
          ]),
          (!loading.value)
            ? (_openBlock(), _createBlock(Pagination, {
                key: 0,
                total: tableDataItems.value,
                page: _unref(creatingShipOrderParams).PageNo,
                "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => ((_unref(creatingShipOrderParams).PageNo) = $event)),
                limit: _unref(creatingShipOrderParams).PageSize,
                "onUpdate:limit": _cache[4] || (_cache[4] = ($event: any) => ((_unref(creatingShipOrderParams).PageSize) = $event)),
                onPagination: getCreatingShipOrderData,
                style: {"margin-top":"20px","text-align":"center"}
              }, null, 8, ["total", "page", "limit"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})